import { render, staticRenderFns } from "./JaasIframe.vue?vue&type=template&id=03b896a4&scoped=true&"
import script from "./JaasIframe.vue?vue&type=script&lang=js&"
export * from "./JaasIframe.vue?vue&type=script&lang=js&"
import style0 from "./JaasIframe.vue?vue&type=style&index=0&id=03b896a4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b896a4",
  null
  
)

export default component.exports